import { FC, ReactElement } from "react"
import { useFormikContext } from "formik"

import { useTranslation } from "react-i18next"

import { TitledCheckbox } from "../../inputs/TitledCheckbox"
import { VerificationCheckboxes, VerificationRole } from "../../inputs/VerificationCheckboxes"

import { FormValuesType } from "./ModalPromoCode"

// Legacy PromoCode field name per verification role (differs from the bonus-template `kyc_required`).
const LEGACY_FIELD: Record<VerificationRole, keyof FormValuesType> = {
  kyc: "kyc",
  email: "email_verified_required",
  phone: "phone_verified_required"
}

export const EligibilityCheckboxes: FC = (): ReactElement => {
  const { t } = useTranslation("translation", { useSuspense: false })
  const { values, setFieldValue, handleChange } = useFormikContext<FormValuesType>()

  return (
    <div className="mt-5">
      {/* Shared KYC / email / phone requirements (also used by the Bonus V2 form). */}
      <VerificationCheckboxes
        kyc={values.kyc ?? false}
        emailVerified={values.email_verified_required ?? false}
        phoneVerified={values.phone_verified_required ?? false}
        onToggle={(role, checked) => setFieldValue(LEGACY_FIELD[role], checked)}
      />
      {/* Promo-only eligibility — not a bonus-template concept, stays here. */}
      <TitledCheckbox
        title={t("promo.newCustomersOnly")}
        checked={values.new_customers_only ?? false}
        onChange={handleChange}
        name="new_customers_only"
        id="new_customers_only"
      />
    </div>
  )
}
